var Link_module_default = { link: "_link_k9ljz_8" };
//#endregion
export { Link_module_default as default };

//# sourceMappingURL=Link.module.js.map